import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "../common/pages/notFound";
import { ClientProvider } from "../common/context/clientContext";
import ClientRoute from "../common/routes/clientRoute";

import Catalog from "../pages/catalogPage";
import SubCategory from "../pages/subcategoryPage";
import DevicePage from "../pages/devicePage";

function Router() {
  const basename = `${process.env.REACT_APP_BASENAME}`
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const relative = basename && currentPath.startsWith(basename) ? currentPath.slice(basename.length) || '/' : currentPath;
  const skipInitialCheck = relative === '/' || relative === '';

  useEffect(() => {
    const company = process.env.REACT_APP_COMPANY;
    if (!company) return;

    const href = `${process.env.PUBLIC_URL || ''}/styles/custom-${company}.css`;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.companyTheme = 'true';

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <BrowserRouter basename={basename}>
      <ClientProvider>
        <Routes>
          <Route path="*" element={<NotFound />} />

          <Route
            path=""
            element={<ClientRoute component={Catalog} />}
          />
          <Route
            path="/"
            element={<ClientRoute component={Catalog} />}
          />
          <Route
            path="/:qr"
            element={<ClientRoute component={Catalog} />}
          />

          <Route
            path="/landing"
            element={<ClientRoute component={Catalog} />}
          />
          <Route
            path="/catalog"
            element={<ClientRoute component={Catalog} />}
          />
          <Route
            path="/catalog/:category"
            element={<ClientRoute component={Catalog} />}
          />
          <Route
            path="/catalog/:category/:subcategory"
            element={<ClientRoute component={SubCategory} />}
          />
          <Route
            path="/product/:id"
            element={<ClientRoute component={DevicePage} />}
          />
        </Routes>
      </ClientProvider>
    </BrowserRouter>
  );
}

export default Router;
